import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { ImagenRadio_Title } from '../../../../../utils/EN/Modals/PostModals';

const ModalPostImagen = () => {
  return (
    <>
      <ModalVideo
        id="imagen-post"
        dataText={ImagenRadio_Title}
        videoSrc="https://player.vimeo.com/video/210349053?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_IMAGEN_RADIO"
      />
    </>
  );
};

export default ModalPostImagen;
